import { FormEventHandler, JSX, useEffect, useState } from "react";
import moment from "moment";
import "moment/locale/sv";
import CrossAlt from "resources/images/svg/cross-black.svg";
import FileUpload from "resources/images/svg/fileUpload.svg";
import FileDone from "resources/images/svg/fileDone.svg";
import SendFile from "resources/images/svg/sendFile.svg";
import { handleBgColor, swedishIt } from "../providers/StylingFunc";

import {
  HorizontalFlex,
  Sect,
  ProButton,
  SpaceBetweenRow,
  VerticalFlex,
} from "pandora/styled";
import { lightGrey, turquoise } from "resources/newColors";
import {
  Anchor,
  BasicButton,
  FileLoader,
  FileSelectBox,
  FileUploadBox,
  FileUploadCard,
  IconButton,
  StatusCard,
  SuccessMessage,
} from "../views/authenticated/styled";
import { addlog, uploadCaseFile } from "Services/Api";
import { DeviationModel } from "./Modals";
import { ApprovalType } from "types";
import { IUser, WorkOrderData } from "DTO/userWorkOrderListDto";
import { useCtx } from "context/SessionDataContext";
import { useAuthCtx } from "context/AuthContext";
import { BaseModal } from "./Modals/BaseModal";
import { Button, Form, ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import { DropDown } from "./DropDown";
import { InfoField } from "./InfoField";

type LeaseInfoProps = {
  WOCaseId: any;
  InquiryType: any;
  Status: any;
  StartDate: any;
  IquirerEmail: any;
  Location: any;
  Assignee: any;
  AssigneeEmail: string;
  CaseAction: any;
  number_of_sites?: any;
  LogoutComponent?: any;
  onChangeWorkOrderStatus?: any;
  GisFileFormat?: any;
  FileCoordinateSystem?: any;
  AdditionalInfo: any;
  Comment: string;
  PropertyDesignation: any;
  CaseName: string;
  Phone: string;
  Mobile: string;
  WorkMethods: string;
  updateLeaseInfo: (wOrder: WorkOrderData) => void;
  Approvals?: ApprovalType;
  Document: Array<string>;
  FieldAppComments?: Array<{
    comment: string;
    timestamp: string;
    user: string;
  }>;
};

const LeaseInfo = (props: LeaseInfoProps) => {
  const [activeHantering, setActiveHantering] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [fieldModal, setFieldModal] = useState(false);

  const {
    WOCaseId,
    InquiryType,
    Status,
    StartDate,
    IquirerEmail,
    Location,
    Assignee,
    AssigneeEmail,
    number_of_sites,
    LogoutComponent,
    CaseAction,
    GisFileFormat,
    FileCoordinateSystem,
    AdditionalInfo,
    Comment,
    PropertyDesignation,
    Approvals,
    updateLeaseInfo,
    Document,
    FieldAppComments,
    CaseName,
    Phone,
    Mobile,
    WorkMethods,
  } = props;

  useEffect(() => {
    setActiveHantering(false);
    setSelectedFile(null);
    setNewAssigne(Assignee);
  }, [WOCaseId]);

  const handleHantering = () => {
    setActiveHantering(true);
  };

  const closeHantering = () => {
    setActiveHantering(false);
    setSelectedFile(null);
  };
  const [newAssigne, setNewAssigne] = useState<string>(Assignee);
  const [progress, setProgress] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const { isMobile, tenantUsers, updateWorkOrderAssinge } = useCtx();
  const { user } = useAuthCtx();

  const handleFileInput = (e) => {
    setProgress(0);
    setSelectedFile(e.target.files[0]);
  };
  const uploadFile = async (file, WOId) => {
    setIsFileUploading(true);
    const uploadStatus = await uploadCaseFile(WOId, file);
    if (uploadStatus) {
      setTimeout(function () {
        markAsDone("done", "Laddat upp fil, Ärendet avslutat");
      }, 2000);
    }
    setIsFileUploading(false);
  };

  //change project staus
  const markAsDone = async (status: string, comment: string) => {
    const updatedStatus = await props.onChangeWorkOrderStatus(
      WOCaseId,
      status,
      comment
    );
    if (updatedStatus) {
      setActiveHantering(false);
    }
  };
  return (
    <>
      <VerticalFlex css="width: 100%;">
        {caseHandlers()}

        {activeHantering && (
          <>
            <IconButton
              css={
                "margin-bottom: 20px; position: relative; width: 18px; color: black; height: auto; left: 95%; top: 10px; z-index: 100"
              }
              src={CrossAlt}
              onClick={closeHantering}
            ></IconButton>

            <FileUploadCard
              css="
          border : 1px solid #06B4C8;
          border-radius: 10px;
          background-color: #3D99F5;
          font-size: 1rem;
          word-break: break-word;
          margin-bottom: 10px;
        "
            >
              <FileUploadBox
                css="
                flex-flow: row wrap;
                padding: 1rem;
                "
              >
                <div style={{ width: "100%" }}>
                  {CaseAction !== "no_action" && (
                    <FileSelectBox
                      css="
                  font-size: 1rem;
                  padding: 0.5rem 1rem;
                  border: 2px dashed rgba(0, 0, 0, 0.15);
                  padding: 1rem;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  margin-bottom: 1rem;
              "
                    >
                      {selectedFile ? (
                        <>
                          {progress === 100 && (
                            <SuccessMessage>{`Uppladdningen lyckades`}</SuccessMessage>
                          )}
                          {progress === 0 && (
                            <>
                              <span style={{ color: "white" }}>
                                <img
                                  width={50}
                                  style={{
                                    filter:
                                      "invert(100%) sepia(100%) saturate(0%) hue-rotate(312deg) brightness(102%) contrast(105%)",
                                  }}
                                  src={FileDone}
                                />
                                {selectedFile.name}
                              </span>

                              <BasicButton
                                style={{
                                  border: `1px solid ${lightGrey}`,
                                  backgroundColor: "rgba(255,255,255)",
                                  borderRadius: "4px",
                                  color: "#000",
                                  textTransform: "uppercase",
                                  fontWeight: "700",
                                  fontSize: "10px",
                                  padding: "10px 18px",
                                  marginTop: 30,
                                }}
                                onClick={() =>
                                  uploadFile(selectedFile, WOCaseId)
                                }
                              >
                                {isFileUploading ? <FileLoader /> : "Skicka"}
                              </BasicButton>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <input
                            type="file"
                            id="file"
                            name="file"
                            style={{ display: "none" }}
                            onChange={handleFileInput}
                          />
                          <img
                            alt="send file"
                            style={{
                              paddingBottom: 20,
                              filter:
                                "invert(100%) sepia(100%) saturate(0%) hue-rotate(312deg) brightness(102%) contrast(105%)",
                            }}
                            width={50}
                            src={SendFile}
                          />
                          <label
                            style={{
                              border: `1px solid ${lightGrey}`,
                              backgroundColor: "rgba(255,255,255)",
                              borderRadius: "4px",
                              color: "#000",
                              textTransform: "uppercase",
                              fontWeight: "700",
                              fontSize: "10px",
                              padding: "10px 18px",
                              transition: "backgroundColor 1s",
                            }}
                            htmlFor={"file"}
                          >
                            <img
                              alt="file upload"
                              style={{ paddingRight: 10 }}
                              width={30}
                              src={FileUpload}
                            />{" "}
                            Välj en fil
                          </label>
                        </>
                      )}
                    </FileSelectBox>
                  )}
                </div>
              </FileUploadBox>
            </FileUploadCard>
          </>
        )}
        {!activeHantering && caseInfo()}
      </VerticalFlex>
      {openModal && (
        <DeviationModel
          WOCaseId={WOCaseId}
          data={Approvals}
          openModal={openModal}
          setOpenModal={setOpenModal}
          Inquirer={IquirerEmail}
          updateCase={updateLeaseInfo}
        />
      )}
    </>
  );

  function caseHandlers() {
    const isClosed = Status === "done" || Status === "completed";
    return (
      <>
        {!isMobile && (
          <HorizontalFlex css="font-weight: 600; font-size: 16px; margin-top: 20px;">
            <Sect
              css={`
                color: ${turquoise};
                margin-right: 5px;
                width: auto;
              `}
            >
              #
            </Sect>
            {WOCaseId}
          </HorizontalFlex>
        )}
        <SpaceBetweenRow css="margin-top: 10px; display:grid; grid-template-columns: auto auto; gap:8px;">
          <FieldHandlers
            isMobile={isMobile}
            isCableIq={InquiryType === "CableInquiry"}
            user={user}
            handleCase={markAsDone}
            assignee={AssigneeEmail}
            openFieldModal={fieldModal}
            setOpenFieldModal={setFieldModal}
            status={Status}
          />
          {Approvals?.accepted === false && (
            <ProButton
              color={`${handleBgColor("approvals")}`}
              hoverColor="#e57575"
              onClick={() => setOpenModal(true)}
            >
              Granska ärende
            </ProButton>
          )}

          <ProButton
            color={`${handleBgColor(Status)}`}
            hoverColor={`${isClosed ? "#3ec17b" : "#e57575"}`}
            onClick={() =>
              markAsDone(
                newStatusText(
                  isClosed,
                  InquiryType === "CableInquiry" ? Assignee : ""
                ),
                Status === "done" ? "" : "Ingen åtgärd krävs, Ärendet avslutat"
              )
            }
          >
            {isClosed ? "Öppna ärende" : "avsluta utan utsättning"}
          </ProButton>

          {CaseAction !== "no_action" &&
            (InquiryType === "ProjectInquiry" || InquiryType === "planning") &&
            Status === "unassigned" &&
            Approvals?.accepted !== false && (
              <ProButton
                color={`${handleBgColor(Status)}`}
                hoverColor="#e57575"
                onClick={handleHantering}
              >
                Hantera ärende
              </ProButton>
            )}
        </SpaceBetweenRow>
      </>
    );
  }

  function caseInfo() {
    const phone =
      typeof Phone === "string" && Phone?.length > 0 ? Phone : Mobile;
    return (
      <>
        {isMobile && <InfoField header="Benämning" value={CaseName} />}
        {<InfoField header="Plats" value={Location} />}
        {
          <InfoField
            header="Startdatum"
            value={moment(StartDate).format("DD MMM YYYY")}
          />
        }
        {
          <InfoField
            header="Förfrågare"
            value={
              <Anchor
                hoverColor={turquoise}
                color={turquoise}
                css={`
                  color: ${turquoise};
                  text-decoration: underline;
                `}
                href={`mailto:${IquirerEmail}`}
              >
                {IquirerEmail}
              </Anchor>
            }
          />
        }
        {InquiryType === "ProjectInquiry" && (
          <InfoField
            header="Fil format"
            value={
              GisFileFormat
                ? `${GisFileFormat}(${FileCoordinateSystem})`
                : `-${GisFileFormat}`
            }
          />
        )}
        {InquiryType !== "ProjectInquiry" && (
          <InfoField
            header="Tekniker"
            value={
              <>
                <DropDown
                  data={tenantUsers
                    .filter((u) => u.role !== "Koordinator")
                    .map((user) => user.name)}
                  title={newAssigne}
                  onclick={(user) => setNewAssigne(user as string)}
                  disabled={Status === "done" || Status === "completed"}
                />
                <Button
                  style={{
                    padding: "revert",
                    alignSelf: "center",
                    marginLeft: "20px",
                    borderRadius: "16px",
                  }}
                  disabled={newAssigne === "" || newAssigne === Assignee}
                  onClick={async () => {
                    const user = tenantUsers.find((a) => a.name === newAssigne);
                    await updateWorkOrderAssinge({
                      case_id: WOCaseId,
                      new_assignee_username: user.username,
                    });
                  }}
                >
                  Tilldela
                </Button>
              </>
            }
          />
        )}
        {isMobile && (
          <InfoField
            header="telefon"
            value={
              <a
                href={`tel:${phone}`}
                onClick={async () =>
                  await addlog({
                    case_id: WOCaseId,
                    activity: `${user.name} har ringt frågeställaren `,
                  })
                }
              >
                {phone}
              </a>
            }
          />
        )}{" "}
        {number_of_sites && (
          <InfoField header="Antal område" value={number_of_sites} />
        )}
        {isMobile && (
          <InfoField header="Ärende typ" value={swedishIt("", InquiryType)} />
        )}
        {isMobile && <InfoField header="Arbetsmetod" value={WorkMethods} />}
        {
          <InfoField
            header="Kommentar"
            value={AdditionalInfo?.length > 0 ? AdditionalInfo : Comment}
          />
        }
        {
          <InfoField
            header="Fastighetsbeteckning"
            value={PropertyDesignation}
          />
        }
        {FieldAppComments?.map((note) => (
          <InfoField header="Anteckning från fält" value={note.comment} />
        ))}
      </>
    );
  }
};

type FieldCaseProps = {
  isMobile: boolean;
  user: IUser;
  assignee: string;
  handleCase: (status: string, comment: string) => Promise<void>;
  openFieldModal: boolean;
  setOpenFieldModal: (boolean) => void;
  status: string;
  isCableIq: boolean;
};

const FieldHandlers = ({
  isMobile,
  user,
  assignee,
  handleCase,
  openFieldModal,
  setOpenFieldModal,
  status,
  isCableIq,
}: FieldCaseProps) => {
  const [value, setValue] = useState("completed");

  if (
    !isMobile ||
    user.role === "Koordinator" ||
    assignee !== user.username ||
    status === "done" ||
    status === "completed" ||
    status === "issue" ||
    !isCableIq
  )
    return <></>;
  const handleChange = (val) => {
    setValue(val);
  };
  const submit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formdata = new FormData(e.currentTarget);
    const data = Object.fromEntries(formdata.entries()) as {
      status: string;
      comment: string | undefined;
    };
    await handleCase(
      data.status,
      data.comment ?? "Ingen åtgärd krävs, Ärendet avslutat"
    );
    setOpenFieldModal(false);
  };
  return (
    <>
      <BaseModal
        show={openFieldModal}
        setShow={setOpenFieldModal}
        title={"Uppdatera status"}
        body={
          <div>
            <Form
              id="fieldCaseForm"
              onSubmit={submit}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <ToggleButtonGroup
                type="radio"
                name="status"
                value={value}
                onChange={handleChange}
                className="status-toggle-group"
              >
                <ToggleButton
                  id="tbg-radio-1"
                  value="completed"
                  variant={"outline-success"}
                >
                  Avslutade
                </ToggleButton>

                <ToggleButton
                  id="tbg-radio-2"
                  value="issue"
                  variant={"outline-danger"}
                >
                  Avvikelse
                </ToggleButton>
              </ToggleButtonGroup>
              {value === "issue" && (
                <Form.Label>
                  {" "}
                  Skriv en kommentar här…
                  <Form.Control
                    as="textarea"
                    placeholder="kommentar..."
                    name="comment"
                  ></Form.Control>
                </Form.Label>
              )}
              <Button
                style={{
                  alignSelf: "start",
                  marginTop: "10px",
                  borderRadius: "16px",
                  padding: "5px",
                }}
                type="submit"
              >
                Spara
              </Button>
            </Form>
          </div>
        }
      />
      <ProButton
        color={`${handleBgColor(status)}`}
        hoverColor="#e57575"
        onClick={setOpenFieldModal} // open modal to handle cases
      >
        Avsluta med utsättning
      </ProButton>
    </>
  );
};

const newStatusText = (isClosed: boolean, assignee?: string): string => {
  if (isClosed && assignee === "") return "unassigned";
  if (isClosed && assignee?.length > 0) return "assigned";
  return "done";
};

export default LeaseInfo;
